import { createFeatureSelector } from '@ngrx/store';
import { State, configFeatureKey } from '../reducers/modals.reducer';

export const selectModal = createFeatureSelector<State>(configFeatureKey);
